import { createSlice } from '@reduxjs/toolkit'
import {
    APPLICATION_STATUS_WITHDRAWN_BY_CLIENT,
    LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION,
    LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION,
    LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION,
    LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION,
    LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION,
    LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION,
    DOCUMENT_TYPE_CRIMINAL_RECORD,
    DOCUMENT_TYPE_EDUCATION_CERTIFICATE,
    DOCUMENT_TYPE_WORK_EXPERIENCE,
    LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_RENEWAL,
    LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_RENEWAL,
    APPLICATION_STATUS_PENDING_PAYMENT,
    APPLICATION_STATUS_APPROVED_ISSUED,
    LICENCE_STATUS_ACTIVE,
    LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL,
    LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL,
    LICENCE_STATUS_NEW,
    LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION,
    LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION,
    LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION,
    LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION,
    LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION,
    DOCUMENT_TYPE_CONTINUING_EDUCATION_CERTIFICATE,
    LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION,
    DOCUMENT_TYPE_BROKER_COURSE_CERTIFICATE,
    APPLICATION_TYPE_MORTGAGE_INDIVIDUAL_BROKER_LICENCE,
    LICENCE_STATUS_EXPIRED,
} from '../../app/constants'
import { fullName, IsDateInFuture } from '../../app/utils'
import { isRenewalTypeApplication, renewalRelatedLicenceSubType } from './applicationsUtils'
import {
    BusinessApplicationInitObject,
    InternalId,
    IsInternalId
} from './primaryAgencyApplicationSlice'

const additionalApplicationsSlice = createSlice({
    name: 'additionalApplications',
    initialState: {
        additionalBranchApplications: [],
        agentApplications: [],
        currentAgentApplicationId: null,
        currentBranchApplicationId: null,
        agentCacheProperties: {}
    },
    reducers: {
        addAdditionalBranchApplication(state, action) {
            const additionalBranchApplication = action.payload
            const index = state.additionalBranchApplications.findIndex(app => app.id === additionalBranchApplication.id)
            if (index >= 0) {
                state.additionalBranchApplications.splice(index, 1, additionalBranchApplication)
            } else {
                state.additionalBranchApplications.push(additionalBranchApplication)
            }
        },
        setAllNewBranchApplicationsProperty(state, action) {
            const { key, value } = action.payload;
            state.additionalBranchApplications = state.additionalBranchApplications.map(branchApp => {
                if (branchApp.applicationStatus === APPLICATION_STATUS_PENDING_PAYMENT) {
                    return {
                        ...branchApp,
                        businessLicenceData: { ...branchApp.businessLicenceData, [key]: value }
                    }
                }
                return branchApp
            })
        },
        markAdditionalApplicationDelete(state, action) {
            const markDeleteFunc = (app) => {
                return {
                    ...app,
                    markedDeleted: true
                }
            }

            state.additionalBranchApplications = state.additionalBranchApplications.map(markDeleteFunc)
            state.agentApplications = state.agentApplications.map(markDeleteFunc)
        },
        resetAdditionalApplications(state, action) {
            state.additionalBranchApplications = []
            state.agentApplications = []
            //state.currentAgentApplicationId = null
        },
        resetAdditionalBranchApplications(state, action) {
            state.additionalBranchApplications = []
        },
        setAllBranchApplicationsLicenceSubType(state, action) {
            state.additionalBranchApplications = state.additionalBranchApplications.map(app => {
                return {
                    ...app,
                    licencingSubType: action.payload
                }
            })
        },
        resetAgentApplications(state, action) {
            state.agentApplications = []
            state.currentAgentApplicationId = null
        },
        removeAdditionalBranchApplicationWithId(state, action) {
            const branchIndex = state.additionalBranchApplications.findIndex(app => app.id === action.payload)

            if (branchIndex >= 0) {
                const branchApp = state.additionalBranchApplications[branchIndex];
                if (IsInternalId(branchApp.id)) {
                    state.additionalBranchApplications.splice(branchIndex, 1)
                } else {
                    const removedBranchApp = { ...branchApp, markedDeleted: true };
                    state.additionalBranchApplications.splice(branchIndex, 1, removedBranchApp)
                }
            }
        },
        removeAgentApplicationWithId(state, action) {
            const index = state.agentApplications.findIndex(app => app.id === action.payload)

            if (index >= 0) {
                state.agentApplications.splice(index, 1)
            }
        },
        setAdditionalBranchApplicationFromBranchData(state, action) {
            const { branches, primaryApplication } = action.payload
            if (branches && Array.isArray(branches)) {
                branches.forEach(branchData => {
                    let branchApplication = null

                    if (branchData.id) {
                        const appIndex = state.additionalBranchApplications.findIndex(app => app.id === branchData.id)

                        delete branchData.id

                        if (appIndex >= 0) {
                            branchApplication = state.additionalBranchApplications[appIndex]
                            branchApplication.businessLicenceData = Object.assign({}, branchApplication.businessLicenceData, { additionalBranches: [branchData] })
                            state.additionalBranchApplications.splice(appIndex, 1, branchApplication)
                        }
                    } else {
                        let branchLicencingSubType = primaryApplication.licencingSubType

                        switch (primaryApplication.licencingSubType) {
                            case LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION:
                            case LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL:
                                branchLicencingSubType = LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION
                                break
                            case LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION:
                            case LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL:
                                branchLicencingSubType = LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION
                                break
                            default:
                                break
                        }

                        branchApplication = BusinessApplicationInitObject(branchLicencingSubType)
                        branchApplication.businessLicenceData = Object.assign({}, branchApplication.businessLicenceData, {
                            additionalBranches: [branchData],
                            businessName: primaryApplication?.businessLicenceData?.businessName
                        })
                        branchApplication.businessApplicationId = primaryApplication.id
                        state.additionalBranchApplications.push(branchApplication)
                    }
                })
            }
        },
        addAgentApplication(state, action) {
            const agentApplication = action.payload
            const index = state.agentApplications.findIndex(agent => agent.id === agentApplication.id)
            if (index >= 0) {
                state.agentApplications.splice(index, 1, agentApplication)
            } else {
                state.agentApplications.push(agentApplication)
            }
        },
        setAdditionalApplications(state, action) {
            const { branchApplications, agentApplications } = action.payload
            const updatedBranchApplications = [...state.additionalBranchApplications]

            branchApplications?.forEach(additionalBranchApplication => {
                const index = updatedBranchApplications.findIndex(app => app.id === additionalBranchApplication.id)
                if (index >= 0) {
                    updatedBranchApplications.splice(index, 1, additionalBranchApplication)
                } else {
                    updatedBranchApplications.push(additionalBranchApplication)
                }
            })

            const updatedAgentApplications = [...state.agentApplications]
            agentApplications?.forEach(agentApplication => {
                const index = updatedAgentApplications.findIndex(agent => agent.id === agentApplication.id)
                if (index >= 0) {
                    updatedAgentApplications.splice(index, 1, agentApplication)
                } else {
                    updatedAgentApplications.push(agentApplication)
                }
            })

            state.additionalBranchApplications = updatedBranchApplications
            state.agentApplications = updatedAgentApplications
        },
        setCurrentAgentApplicationId(state, action) {
            state.currentAgentApplicationId = action.payload
        },
        addNewAgentApplication(state, action) {

            const {
                agentLicenceSubType,
                primaryApplicationLicencingSubType,
                businessApplicationId,
                businessName,
                companyRjscDetails,
                companyTrademark
            } = action.payload

            let licenceSubType = agentLicenceSubType

            if (!licenceSubType) {
                if (primaryApplicationLicencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION
                    || primaryApplicationLicencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL) {
                    licenceSubType = LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION
                } else if (primaryApplicationLicencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION
                    || primaryApplicationLicencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL) {
                    licenceSubType = LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION
                } else if (primaryApplicationLicencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION
                    || primaryApplicationLicencingSubType === LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION) {
                    licenceSubType = LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION
                } else {
                    console.error("primary agency and agent sub-types are not known! Setting default as collector application.")
                    licenceSubType = LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION
                }
            }

            const businessApplication = BusinessApplicationInitObject(licenceSubType)
            businessApplication.businessApplicationId = businessApplicationId
            businessApplication.businessLicenceData.businessName = businessName
            businessApplication.businessLicenceData.companyRjscDetails = companyRjscDetails
            businessApplication.businessLicenceData.companyTrademark = companyTrademark

            businessApplication.name = businessName
            state.agentApplications.push(businessApplication)
            state.currentAgentApplicationId = businessApplication.id
        },
        setCurrentCollectorCompanyRjscDetails(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                agentApplication.businessLicenceData = Object.assign({}, agentApplication.businessLicenceData, { companyRjscDetails: action.payload })
                state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
            }
        },
        setCurrentCollectorCompanyTrademark(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                agentApplication.businessLicenceData = Object.assign({}, agentApplication.businessLicenceData, { companyTrademark: action.payload })
                state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
            }
        },
        // setCurrentAgentAsPrincipalBroker(state, action) {
        //     const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

        //     if(currentAgentApplicationIndex >= 0) { 
        //         const agentApplication = state.agentApplications[currentAgentApplicationIndex]
        //         agentApplication.businessLicenceData = Object.assign({},agentApplication.businessLicenceData,{isPrincipalBroker : true})
        //         state.agentApplications.splice(currentAgentApplicationIndex,1,agentApplication)
        //     }
        // },
        setCurrentAgentPersonDetails(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                agentApplication.businessLicenceData = Object.assign({}, agentApplication.businessLicenceData, { personData: action.payload })
                agentApplication.contactName = fullName(action.payload)
                state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
            }
        },
        setCurrentAgentCriminalHistoryDetails(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                agentApplication.businessLicenceData = Object.assign({}, agentApplication.businessLicenceData, { criminalHistoryData: action.payload })
                state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
            }
        },
        setCurrentAgentCriminalRecordsDocuments(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                const otherDocs = agentApplication.documents ? agentApplication.documents.filter(docs => docs.documentType !== DOCUMENT_TYPE_CRIMINAL_RECORD) : []
                agentApplication.documents = [...otherDocs, ...action.payload]

                state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
            }

        },
        replaceCurrentAgentDocument: (state, action) => {
            const docObj = { ...action.payload }
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                const docIndex = agentApplication.documents.findIndex(d => d.id === docObj.id)
                if (docIndex !== -1) {
                    const documentAfterReplace = [...agentApplication.documents]
                    documentAfterReplace.splice(docIndex, 1, docObj)
                    agentApplication.documents = documentAfterReplace
                    state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
                }
            }

        },
        addCurrentAgentContinuingEducationCertificate(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)
            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                let documentReplaced = false

                if (action.payload.id && !IsInternalId(action.payload.id)) {
                    const documentIndex = agentApplication.documents.findIndex(doc => doc.id === action.payload.id)
                    if (documentIndex !== -1) {
                        const updatedDocuments = [...agentApplication.documents]
                        updatedDocuments.splice(documentIndex, 1, action.payload)
                        agentApplication.documents = updatedDocuments
                        documentReplaced = true
                    }
                }

                if (!documentReplaced) {
                    agentApplication.documents = [...agentApplication.documents.filter(d => (d.changeType === "DELETE" || d.documentType !== DOCUMENT_TYPE_CONTINUING_EDUCATION_CERTIFICATE)), action.payload]
                }

                state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
            }
        },
        addCurrentAgentBrokerCourseCertificate(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)
            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                let documentReplaced = false

                if (action.payload.id && !IsInternalId(action.payload.id)) {
                    const documentIndex = agentApplication.documents.findIndex(doc => doc.id === action.payload.id)
                    if (documentIndex !== -1) {
                        const updatedDocuments = [...agentApplication.documents]
                        updatedDocuments.splice(documentIndex, 1, action.payload)
                        agentApplication.documents = updatedDocuments
                        documentReplaced = true
                    }
                }

                if (!documentReplaced) {
                    agentApplication.documents = [...agentApplication.documents.filter(d => (d.changeType === "DELETE" || d.documentType !== DOCUMENT_TYPE_BROKER_COURSE_CERTIFICATE)), action.payload]
                }

                state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
            }
        },
        addCurrentAgentEducationCertificate(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)
            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                let documentReplaced = false

                if (action.payload.id && !IsInternalId(action.payload.id)) {
                    const documentIndex = agentApplication.documents.findIndex(doc => doc.id === action.payload.id)
                    if (documentIndex !== -1) {
                        const updatedDocuments = [...agentApplication.documents]
                        updatedDocuments.splice(documentIndex, 1, action.payload)
                        agentApplication.documents = updatedDocuments
                        documentReplaced = true
                    }
                }

                if (!documentReplaced) {
                    agentApplication.documents = [...agentApplication.documents.filter(d => (d.changeType === "DELETE" || d.documentType !== DOCUMENT_TYPE_EDUCATION_CERTIFICATE)), action.payload]
                }

                state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
            }
        },
        addCurrentAgentWorkHistoryDocuments(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)
            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                agentApplication.documents = [...agentApplication.documents.filter(d => d.documentType !== DOCUMENT_TYPE_WORK_EXPERIENCE), ...action.payload]
                state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
            }
        },
        addCurrentAgentSupportingDocument(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)
            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]

                let docObj = { ...action.payload }
                if (!docObj.id) {
                    docObj.id = InternalId()
                    agentApplication.documents = [...agentApplication.documents, docObj]
                } else {
                    // search and replace with the id
                    const docId = agentApplication.documents.findIndex(doc => (doc.id && (doc.id.toString() === docObj.id.toString())))
                    if (docId >= 0) {
                        agentApplication.documents.splice(docId, 1, docObj)
                    } else {
                        agentApplication.documents = [...agentApplication.documents, docObj]
                    }
                }
                state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
            }
        },
        addAgentDocumentsToUpload(state, action) {
            const agentApplicationId = action.payload.agentApplicationId;
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === agentApplicationId)
            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]

                const documents = action.payload.documents
                documents?.forEach((docObj) => {
                    if (!docObj.id) {
                        docObj.id = InternalId();
                    }

                })
                if (agentApplication.documents) {
                    agentApplication.documents = [...agentApplication.documents, ...documents]
                }
                else {
                    agentApplication.documents = [...documents]
                }

                state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
            }
        },
        setCurrentAgentWorkHistoryDetails(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                agentApplication.businessLicenceData = Object.assign({}, agentApplication.businessLicenceData, { workHistoryData: action.payload })
                state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
            }
        },
        setCurrentAgentLicenceSuspsnsionDetails(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                agentApplication.businessLicenceData = Object.assign({}, agentApplication.businessLicenceData, { licenceSuspendedData: action.payload })
                state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
            }
        },
        setCurrentAgentApplicationStatus(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                state.agentApplications.splice(currentAgentApplicationIndex, 1, Object.assign({}, agentApplication, { applicationStatus: action.payload }))
            }
        },
        setCurrentAgentLicenceStatus(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                state.agentApplications.splice(currentAgentApplicationIndex, 1, Object.assign({}, agentApplication, { licenceStatus: action.payload }))
            }
        },
        setCurrentAgentLicenceSubType(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                state.agentApplications.splice(currentAgentApplicationIndex, 1, Object.assign({}, agentApplication, { licencingSubType: action.payload }))
            }
        },
        setCurrentAgentLicenceExpiryDate(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                state.agentApplications.splice(currentAgentApplicationIndex, 1, Object.assign({}, agentApplication, { endDate: action.payload }))
            }
        },
        setCurrentAgentInternalNotes(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                agentApplication.businessLicenceData = Object.assign({}, agentApplication.businessLicenceData, { internalNotes: action.payload })
                state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
            }
        },
        setCurrentAgentInternalNoteList(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                agentApplication.businessLicenceData = Object.assign({}, agentApplication.businessLicenceData, { internalNoteList: action.payload })

                state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
            }
        },
        setCurrentAgentApplicationLocked(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                state.agentApplications.splice(currentAgentApplicationIndex, 1, Object.assign({}, agentApplication, { locked: action.payload }))
            }
        },
        setCurrentAgentMBLRALicenceNumber: (state, action) => {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                agentApplication.businessLicenceData = Object.assign({}, agentApplication.businessLicenceData, { mblraLicenceNumber: action.payload })
                state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
            }
        },
        setCurrentAgentMortgageProperty: (state, action) => {
            const { key, value } = action.payload;

            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                agentApplication.businessLicenceData = Object.assign({}, agentApplication.businessLicenceData, Object.defineProperty({}, key, { value: value, writable: true, enumerable: true }))
                state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
            }
        },
        setCurrentAgentPreviouslyLicencedStatus: (state, action) => {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                agentApplication.businessLicenceData = Object.assign({}, agentApplication.businessLicenceData, { previouslyLicencedStatus: action.payload })
                state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
            }
        },
        setCurrentAgentRegulatoryInformationReceivedDate: (state, action) => {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                agentApplication.businessLicenceData = Object.assign({}, agentApplication.businessLicenceData, { confirmSuretyBond: action.payload })
                state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
            }
        },
        setCurrentAgentDocumentsIsUpdatedReset(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)
            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                agentApplication.documents = agentApplication.documents?.map((doc)=>{
                    if(doc.isUpdated) {
                        doc.isUpdated = false;
                        doc.changeType = "UPDATE";
                    }
                    return doc
                })

                state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
            }
        },
        removeAgentApplication(state, action) {
            const agentApplicationIndex = state.agentApplications.findIndex(app => app.id === action.payload)

            if (agentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[agentApplicationIndex]
                state.agentApplications.splice(agentApplicationIndex, 1, {
                    ...agentApplication,
                    ...{ changeType: "DELETE" }
                })
            }
        },
        markAgentApplicationDeleted(state, action) {
            const agentApplicationIndex = state.agentApplications.findIndex(app => app.id === action.payload)

            if (agentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[agentApplicationIndex]
                state.agentApplications.splice(agentApplicationIndex, 1, Object.assign({}, agentApplication, { markedDeleted: true }))
            }
        },
        withdrawAgentApplication(state, action) {
            const agentApplicationIndex = state.agentApplications.findIndex(app => app.id === action.payload)

            if (agentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[agentApplicationIndex];
                agentApplication.businessLicenceData = Object.assign({}, agentApplication.businessLicenceData, { cancelSubmittedDate: Date.now(), reviewDataCollectionDebt:null })
                state.agentApplications.splice(agentApplicationIndex, 1, Object.assign({}, agentApplication, {
                    applicationStatus: APPLICATION_STATUS_WITHDRAWN_BY_CLIENT,
                }))
            }
        },
        replaceAllAgentApplications(state, action) {
            state.agentApplications = action.payload

            if (Array.isArray(action.payload) && action.payload.length > 0) {
                state.currentAgentApplicationId = action.payload[0].id
            }
        },
        replaceAgentApplication(state, action) {
            const { agentApplication } = action.payload
            const index = state.agentApplications.findIndex(agent => agent.id === agentApplication.id)
            if (index >= 0) {
                state.agentApplications.splice(index, 1, agentApplication)
            }
        },
        updateBLTAgentApplicationReviewItem(state, action) {
            const { key, item } = action.payload
            const reviewItemIndex = action.payload.reviewItemIndex

            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                let reviewData = agentApplication.businessLicenceData.reviewDataCollectionDebt

                const compareReviewData = (storeItem, updatedItem, sItemIndex) => {
                    if (!isNaN(reviewItemIndex) && reviewItemIndex !== sItemIndex) {
                        return false;
                    }
                    for (const _k in storeItem) {

                        if (_k === "review" || _k === "document")
                            continue

                        if (Object.hasOwnProperty.call(storeItem, _k)) {
                            if (Object.hasOwnProperty.call(updatedItem, _k)) {
                                const e = storeItem[_k];
                                const element = updatedItem[_k];

                                if (e !== element) {
                                    return false
                                }
                            } else {
                                return false
                            }
                        }
                    }
                    return true
                }

                if (key === "brokerLicenceHistoryMap1"
                    || key === "brokerEducationRequirementMap1"
                    || key === "brokerCriminalRecordCheckMap1"
                    || key === "brokerConfirmationInformationMap"
                    || key === "updatedDocumentsMap"
                ) {
                    reviewData[key] = item
                    agentApplication.businessLicenceData = Object.assign({}, agentApplication.businessLicenceData, { reviewDataCollectionDebt: reviewData })
                    state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
                } else {
                    if (reviewData[key] && Array.isArray(reviewData[key])) {
                        let storeItems = [...reviewData[key]]
                        let storeIndex = -1
                        let storeItem = storeItems.find((_sItem, index) => {
                            if (_sItem.data !== null || _sItem.data !== undefined) {

                                if (key === "brokerRegulatoryInformationMap" && index === reviewItemIndex) {
                                    storeIndex = index
                                    return true
                                } else {
                                    if (compareReviewData(_sItem, item, index)) {
                                        storeIndex = index
                                        return true
                                    }
                                }
                            }

                            return false
                        })

                        if (storeItem && storeIndex >= 0) {

                            storeItems.splice(storeIndex, 1, item)
                            reviewData[key] = storeItems

                            agentApplication.businessLicenceData = Object.assign({}, agentApplication.businessLicenceData, { reviewDataCollectionDebt: reviewData })
                            state.agentApplications.splice(currentAgentApplicationIndex, 1, agentApplication)
                        }
                    }
                }
            }
        },
        renewAgentApplicationsWithId(state, action) {
            const agentApplicationIds = action.payload
            const agentApps = [...state.agentApplications]
            const renewedApplications = agentApps.map(app => {

                if (agentApplicationIds.findIndex(aId => app.id === aId) !== -1) {
                    if (app.licencingSubType === LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION) {
                        app.licencingSubType = LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_RENEWAL
                    } else if (app.licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION) {
                        app.licencingSubType = LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_RENEWAL
                    }

                    app.applicationStatus = APPLICATION_STATUS_PENDING_PAYMENT
                }

                return app
            })
            state.agentApplications = renewedApplications
        },
        setBranchApplicationsForRenewal(state, action) {
            const branchApps = [...state.additionalBranchApplications]
            const licenceTypeDetails = action.payload?.licenceTypeDetails
            const renewalEndDate = licenceTypeDetails?.renewalGraceDate ?? licenceTypeDetails?.renewalEndDate

            const modifiedBranchApplications = branchApps.map(app => {
                // case - licence has expired (post expiry date) but still in grace period
                const isExpiredInGracePeriod = ((app?.licenceStatus === LICENCE_STATUS_EXPIRED) && IsDateInFuture(renewalEndDate))
                if (!app.markedDoNotRenew && !app.markedDeleted && (app.licenceStatus === LICENCE_STATUS_ACTIVE || isExpiredInGracePeriod)) {
                    if (app.licencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION) {
                        app.licencingSubType = LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL
                    } else if (app.licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION) {
                        app.licencingSubType = LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL
                    }
                    app.applicationStatus = APPLICATION_STATUS_PENDING_PAYMENT
                    app.licenceStatus = LICENCE_STATUS_NEW
                }
                return app
            })
            state.additionalBranchApplications = modifiedBranchApplications
        },
        setAgentApplicationsDoNotRenew(state, action) {
            const {
                agentApplicationIds,
            } = action.payload

            if (agentApplicationIds?.length) {
                const agentApps = [...state.agentApplications]
                const modifiedAgenthApplications = agentApps.map(app => {
                    if (agentApplicationIds.findIndex(aId => app.id === aId) !== -1) {
                        if (isRenewalTypeApplication(app)) {
                            let resetLicenceSubType = LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION
                            switch (app.licencingSubType) {
                                case LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_RENEWAL:
                                    resetLicenceSubType = LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION
                                    break;
                                case LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_RENEWAL:
                                    resetLicenceSubType = LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION
                                    break;
                                case LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION:
                                    resetLicenceSubType = LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION
                                    break;
                                case LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION:
                                    resetLicenceSubType = LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION
                                    break
                                case LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION:
                                    resetLicenceSubType = LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION
                                    break
                                default:
                                    resetLicenceSubType = LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION
                                    break

                            }
                            app.licencingSubType = resetLicenceSubType
                            app.licenceStatus = LICENCE_STATUS_ACTIVE
                            app.applicationStatus = APPLICATION_STATUS_APPROVED_ISSUED
                        }

                        // this flag will prevent the UI from showing this application 
                        // again in the application renew the next time.
                        app.markedDoNotRenew = true
                    }

                    return app
                })
                state.agentApplications = modifiedAgenthApplications
            }
        },
        setAdditionalBranchApplicationsMarkDeleted(state, action) {
            const {
                branchApplicationIds,
            } = action.payload

            const branchApps = [...state.additionalBranchApplications]
            const modifiedBranchApplications = branchApps.map(app => {
                if (branchApplicationIds.findIndex(aId => app.id === aId) !== -1) {
                    app.markedDeleted = true
                }
                return app;
            })
            state.additionalBranchApplications = modifiedBranchApplications
        },
        setAdditionalBranchApplicationsMarkDoNotRenew(state, action) {
            const {
                branchApplicationIds,
            } = action.payload

            const branchApps = [...state.additionalBranchApplications]

            const modifiedBranchApplications = branchApps.map(app => {
                if (branchApplicationIds.findIndex(aId => app.id === aId) !== -1) {
                    // resetting the main parameters which were changed at the time of 
                    // application renewal
                    // Change : applicationStatus = APPROVED
                    //          licenceStatus = ACTIVE
                    //          licencingSubType = original type (without the renewal)
                    if (isRenewalTypeApplication(app)) {
                        // for now, there are only two choices for branch application licence sub type
                        app.licencingSubType = (app.licencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL) ?
                            LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION :
                            LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION
                        app.licenceStatus = LICENCE_STATUS_ACTIVE
                        app.applicationStatus = APPLICATION_STATUS_APPROVED_ISSUED
                    }
                    // this flag will prevent the UI from showing this application 
                    // again in the application renew the next time.
                    app.markedDoNotRenew = true
                }
                return app
            })
            state.additionalBranchApplications = modifiedBranchApplications
        },
        editAdditionalBranchField(state, action) {
            const { branchApplicationId, branchObject } = action.payload

            const branchApps = [...state.additionalBranchApplications]
            const modifiedBranchApplications = branchApps.map(app => {
                if (branchApplicationId === app.id) {
                    if (app.businessLicenceData?.additionalBranches?.length === 1) {
                        app.businessLicenceData.additionalBranches = [{
                            ...app.businessLicenceData?.additionalBranches[0],
                            ...branchObject
                        }]
                    }
                }

                return app
            })
            state.additionalBranchApplications = modifiedBranchApplications
        },
        setCurrentAgentApplicationForRenewal(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                const licenceSubType = renewalRelatedLicenceSubType(agentApplication.licencingSubType)
                const appData = agentApplication.businessLicenceData ?? {}

                const updatedAgentApplication = {
                    ...agentApplication,
                    licenceStatus: LICENCE_STATUS_NEW,
                    applicationStatus: APPLICATION_STATUS_PENDING_PAYMENT,
                    licencingSubType: licenceSubType,
                    businessLicenceData: {
                        ...appData,
                        criminalHistoryData: null,
                        reviewDataCollectionDebt: null,
                        licenceSuspendedData: null,
                        userApplicationReviewComplete: false,
                        licenceUpgradeApplicationId: 0,
                        brokerLicenceNumber: null,
                        currentlyBrokerInNS: false
                    }
                }

                state.agentApplications.splice(currentAgentApplicationIndex, 1, updatedAgentApplication)
            }
        },
        setAssociateBrokerLicenceForUpgrade(state, action) {
            const currentAgentApplicationIndex = state.agentApplications.findIndex(app => app.id === state.currentAgentApplicationId)

            if (currentAgentApplicationIndex >= 0) {
                const agentApplication = state.agentApplications[currentAgentApplicationIndex]
                const licenceSubType = LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION
                const appData = agentApplication.businessLicenceData ?? {}

                const updatedAgentApplication = {
                    ...agentApplication,
                    id: InternalId(),
                    changeType: "SAVE",
                    applicationStatus: APPLICATION_STATUS_PENDING_PAYMENT,
                    applicationType: APPLICATION_TYPE_MORTGAGE_INDIVIDUAL_BROKER_LICENCE,
                    businessApplicationHistoryData: [],
                    licenceNumber: "",
                    licenceStatus: LICENCE_STATUS_NEW,
                    licencingSubType: licenceSubType,
                    locked: null,
                    endDate: null,
                    submittedDate: 0,
                    markedDeleted: false,
                    markedDoNotRenew: false,
                    documents: [],
                    businessLicenceData: {
                        ...appData,
                        licenceUpgradeApplicationId: agentApplication.id, // used to identify upgrade during adjudication
                        criminalHistoryData: null,
                        reviewDataCollectionDebt: null,
                        licenceSuspendedData: null,
                        userApplicationReviewComplete: false,
                        previouslyLicencedStatus: null,
                        internalNoteList: null,
                        internalNotes: null,
                        brokerLicenceNumber: null,
                        currentlyBrokerInNS: false
                    }
                }

                state.agentApplications.push(updatedAgentApplication)
                state.currentAgentApplicationId = updatedAgentApplication.id;
            }
        },
        setAgentCacheProperty: (state, action) => {
            const { key, value } = action.payload;
            state.agentCacheProperties[key] = value;
        },
        setCurrentBranchApplicationId: (state, action) => {
            state.currentBranchApplicationId = action.payload;
        },
        setCurrentBranchApplicationStatus: (state, action) => {
            let currentBranchApplicationId = state.currentBranchApplicationId;
            if (!currentBranchApplicationId && state.additionalBranchApplications?.length === 1) {
                currentBranchApplicationId = state.additionalBranchApplications[0].id;
                state.currentBranchApplicationId = currentBranchApplicationId;
            }
            const branchApps = [...state.additionalBranchApplications]
            const appStatus = action.payload

            const modifiedBranchApplications = branchApps.map(app => {
                if (app.id === currentBranchApplicationId) {
                    app.applicationStatus = appStatus
                }
                return app
            })
            state.additionalBranchApplications = modifiedBranchApplications
        },
        setCurrentBranchApplicationLicenceStatus: (state, action) => {
            let currentBranchApplicationId = state.currentBranchApplicationId;
            if (!currentBranchApplicationId && state.additionalBranchApplications?.length === 1) {
                currentBranchApplicationId = state.additionalBranchApplications[0].id;
                state.currentBranchApplicationId = currentBranchApplicationId;
            }
            const branchApps = [...state.additionalBranchApplications]
            const licenceStatus = action.payload

            const modifiedBranchApplications = branchApps.map(app => {
                if (app.id === currentBranchApplicationId) {
                    app.licenceStatus = licenceStatus
                }
                return app
            })
            state.additionalBranchApplications = modifiedBranchApplications
        },
        setCurrentBranchApplicationLocked: (state, action) => {
            let currentBranchApplicationId = state.currentBranchApplicationId;
            if (!currentBranchApplicationId && state.additionalBranchApplications?.length === 1) {
                currentBranchApplicationId = state.additionalBranchApplications[0].id;
                state.currentBranchApplicationId = currentBranchApplicationId;
            }
            const branchApps = [...state.additionalBranchApplications]

            const modifiedBranchApplications = branchApps.map(app => {
                if (app.id === currentBranchApplicationId) {
                    app.locked = action.payload
                }
                return app
            })
            state.additionalBranchApplications = modifiedBranchApplications
        },
        setCurrentBranchApplicationReviewData: (state, action) => {
            let currentBranchApplicationId = state.currentBranchApplicationId;
            if (!currentBranchApplicationId && state.additionalBranchApplications?.length === 1) {
                currentBranchApplicationId = state.additionalBranchApplications[0].id;
                state.currentBranchApplicationId = currentBranchApplicationId;
            }
            const branchApps = [...state.additionalBranchApplications]
            const reviewData = action.payload

            const modifiedBranchApplications = branchApps.map(app => {
                if (app.id === currentBranchApplicationId) {
                    app.businessLicenceData = {
                        ...app.businessLicenceData,
                        reviewDataCollectionDebt: reviewData
                    }
                }
                return app
            })
            state.additionalBranchApplications = modifiedBranchApplications
        },
        setCurrentBranchApplicationInternalNotes: (state, action) => {
            let currentBranchApplicationId = state.currentBranchApplicationId;
            if (!currentBranchApplicationId && state.additionalBranchApplications?.length === 1) {
                currentBranchApplicationId = state.additionalBranchApplications[0].id;
                state.currentBranchApplicationId = currentBranchApplicationId;
            }
            const branchApps = [...state.additionalBranchApplications]
            const internalNotes = action.payload

            const modifiedBranchApplications = branchApps.map(app => {
                if (app.id === currentBranchApplicationId) {
                    app.businessLicenceData = {
                        ...app.businessLicenceData,
                        internalNoteList: internalNotes
                    }
                }
                return app
            })
            state.additionalBranchApplications = modifiedBranchApplications
        },
        updateBLTBranchApplicationReviewItem(state, action) {
            const { key, item, reviewItemIndex } = action.payload

            let currentBranchApplicationId = state.currentBranchApplicationId;
            let branchApplicationIndex = null;
            let branchApplication = null;

            if (!currentBranchApplicationId && state.additionalBranchApplications?.length === 1) {
                branchApplicationIndex = 0;
                branchApplication = state.additionalBranchApplications[0]
                currentBranchApplicationId = state.additionalBranchApplications[0].id;

                state.currentBranchApplicationId = currentBranchApplicationId;
            } else {
                branchApplicationIndex = state.additionalBranchApplications.findIndex(app => app.id === currentBranchApplicationId)
                if (branchApplicationIndex >= 0)
                    branchApplication = state.additionalBranchApplications[branchApplicationIndex]
            }

            if (branchApplication) {
                let reviewData = branchApplication.businessLicenceData.reviewDataCollectionDebt
                /* 
                 This function checks the detail which is being reviewed. For now, the check is 
                 only for the string values. For everything else (like arrays etc) add the key 
                 in the first if case to avoid any comparison checks.
                */
                const compareReviewData = (storeItem, updatedItem, sItemIndex) => {
                    // If two items are identical then the index breaks the tie
                    if (!isNaN(reviewItemIndex) && reviewItemIndex !== sItemIndex) {
                        return false;
                    }
                    for (const _k in storeItem) {
                        if (_k === "review")
                            continue

                        if (Object.hasOwnProperty.call(storeItem, _k)) {
                            if (Object.hasOwnProperty.call(updatedItem, _k)) {
                                const e = storeItem[_k];
                                const element = updatedItem[_k];

                                if (e !== element) {
                                    return false
                                }
                            } else {
                                return false
                            }
                        }
                    }
                    return true
                }

                if (reviewData[key] && Array.isArray(reviewData[key])) {
                    let storeItems = [...reviewData[key]]
                    let storeIndex = -1
                    let storeItem = storeItems.find((_sItem, index) => {
                        if (_sItem.data !== null || _sItem.data !== undefined) {
                            if (compareReviewData(_sItem, item, index)) {
                                storeIndex = index
                                return true
                            }
                        }

                        return false
                    })

                    if (storeItem && storeIndex >= 0) {
                        storeItems.splice(storeIndex, 1, item)
                        branchApplication.businessLicenceData.reviewDataCollectionDebt[key] = storeItems
                        state.additionalBranchApplications.splice(branchApplicationIndex, 1, branchApplication)
                    }
                }
            }
        },
        // setAllIndividualRenewalApplicationApplicationStatus(state, action) {
        //     const {
        //         agentApplications,
        //     } = action.payload

        //     state.agentApplications = agentApplications.map(agentApp => {
        //         if(isRenewalTypeApplication(agentApp)) {
        //             agentApp.applicationStatus = action.payload
        //         }
        //         return agentApp
        //     })
        // },
        // setAllIndividualRenewalApplicationLicenceStatus(state, action) {
        //     const {
        //         agentApplications,
        //     } = action.payload

        //     state.agentApplications = agentApplications.map(agentApp => {
        //         if(isRenewalTypeApplication(agentApp)) {
        //             agentApp.licenceStatus = action.payload
        //         }
        //         return agentApp
        //     })
        // }
    }
})

export const {
    addAdditionalBranchApplication,
    setAllNewBranchApplicationsProperty,
    resetAdditionalApplications,
    markAdditionalApplicationDelete,
    resetAdditionalBranchApplications,
    setAllBranchApplicationsLicenceSubType,
    resetAgentApplications,
    removeAdditionalBranchApplicationWithId,
    removeAgentApplicationWithId,
    addAgentApplication,
    setCurrentAgentApplicationId,
    addNewAgentApplication,
    setAdditionalApplications,
    // setCurrentAgentAsPrincipalBroker,
    setCurrentAgentPersonDetails,
    setCurrentCollectorCompanyRjscDetails,
    setCurrentCollectorCompanyTrademark,
    setCurrentAgentCriminalHistoryDetails,
    setCurrentAgentCriminalRecordsDocuments,
    replaceCurrentAgentDocument,
    addCurrentAgentBrokerCourseCertificate,
    addCurrentAgentEducationCertificate,
    addCurrentAgentContinuingEducationCertificate,
    addCurrentAgentWorkHistoryDocuments,
    addCurrentAgentSupportingDocument,
    addAgentDocumentsToUpload,
    setCurrentAgentWorkHistoryDetails,
    setCurrentAgentLicenceSuspsnsionDetails,
    setCurrentAgentApplicationStatus,
    setCurrentAgentLicenceStatus,
    setCurrentAgentLicenceSubType,
    setCurrentAgentLicenceExpiryDate,
    setCurrentAgentInternalNotes,
    setCurrentAgentInternalNoteList,
    setCurrentAgentApplicationLocked,
    setCurrentAgentMBLRALicenceNumber,
    setCurrentAgentMortgageProperty,
    setCurrentAgentPreviouslyLicencedStatus,
    setCurrentAgentRegulatoryInformationReceivedDate,
    removeAgentApplication,
    markAgentApplicationDeleted,
    withdrawAgentApplication,
    setAdditionalBranchApplicationFromBranchData,
    replaceAllAgentApplications,
    replaceAgentApplication,
    updateBLTAgentApplicationReviewItem,
    renewAgentApplicationsWithId,
    setBranchApplicationsForRenewal,
    setAgentApplicationsDoNotRenew,
    setAdditionalBranchApplicationsMarkDeleted,
    setAdditionalBranchApplicationsMarkDoNotRenew,
    editAdditionalBranchField,
    setCurrentAgentApplicationForRenewal,
    setAgentCacheProperty,
    setCurrentBranchApplicationId,
    setCurrentBranchApplicationStatus,
    setCurrentBranchApplicationLicenceStatus,
    setCurrentBranchApplicationLocked,
    setCurrentBranchApplicationReviewData,
    setCurrentBranchApplicationInternalNotes,
    updateBLTBranchApplicationReviewItem,
    setAssociateBrokerLicenceForUpgrade,
    setCurrentAgentDocumentsIsUpdatedReset
} = additionalApplicationsSlice.actions

export default additionalApplicationsSlice.reducer
